import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, Div, F } from 'components/Ui';
import InvoiceEmailBlock from 'containers/PrimoProfile/BillingInformation/InvoiceForm/InvoiceEmailBlock';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';
import { GTM_TRACKING_TAGS } from 'utils/constants';
import styles from './styles.scss';

const StatementSettings = ({ values, onChange }) => {
  const onPaperlessChange = (isChecked) => {
    setFeeMsg(isChecked);
    onChange('paperlessEnabled', isChecked);
  };

  const onEmailChange = (emails) => {
    onChange('email', [emails]);
  };

  const [showPaperlessMsg, setFeeMsg] = useState(values.paperlessEnabled);

  return (
    <div
      className={styles.container}
      data-tracking={`Saving ${GTM_TRACKING_TAGS.eInvoice} preferences`}
    >
      <Div className={styles.title}>Edit eInvoice preferences</Div>
      <hr className={styles.divider} />

      <Checkbox
        label="Enroll in eInvoice"
        isRectangle
        labelClassName={styles.checkbox}
        defaultChecked={values.paperlessEnabled}
        onChange={onPaperlessChange}
      />
      <hr className={styles.divider} />
      {showPaperlessMsg ? (
        <Fragment>
          <Div className={styles.statementHeader}>Email Address:</Div>
          {values.email &&
            values.email.map((data) => (
              <InvoiceEmailBlock data={data} onEmailChange={onEmailChange} />
            ))}
        </Fragment>
      ) : (
        <div>
          <div className={styles.warning}>
            <WarningOutlinedIcon />
          </div>
          <Div className={styles.warningHeader}>Heads up</Div>
          <div className={styles.feeMessage}>
            <p>
              <F>
                Because you are not on AutoPay, you will receive a paper bill.
                Enroll in eInvoice to receive your invoices by email, or you can
                visit
              </F>
              <Button
                text="Billing and Delivery History"
                href="/account/past-orders"
                link
                data-tracking={`Saving the email for ${GTM_TRACKING_TAGS.eInvoice} preferences`}
              />{' '}
              <F>in My Account to see all past invoices.</F>
            </p>
            {/* <p> */}
            {/*  By opting out of eInvoice, you acknowledge that you will incur an additional $4.00 fee */}
            {/*  for each paper invoice mailed to you. */}
            {/* </p> */}
            {/* <p> */}
            {/*  This is your billing address where your invoice will be mailed. Please call 800-492-8377 if you need to change this address. */}
            {/* </p> */}
          </div>
          {/* <div className={styles.address}>
            <div>Paper invoice address</div>
            <BillingAddressView />
          </div> */}
        </div>
      )}
    </div>
  );
};

StatementSettings.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default StatementSettings;
